// extracted by mini-css-extract-plugin
export default {"card":"BannerDetail_card__740ix","search":"BannerDetail_search__CNI1Q","maxHeight":"BannerDetail_maxHeight__WeS+3","detail":"BannerDetail_detail__769QN"};